var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-group"},_vm._l((_vm.buttons),function(button){return _c('button',{key:button.value,class:{
			selected: _vm.selectedButton && _vm.selectedButton.value == button.value
		},attrs:{"data-cy":("tip-option-" + (button.name))},on:{"click":function($event){_vm.onButtonClicked(button)}}},[_vm._v("\n\t\t"+_vm._s(button.name)+"\n\t")])}))}
var staticRenderFns = []

export { render, staticRenderFns }